
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sounargreining",
      function () {
        return require("private-next-pages/sounargreining.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sounargreining"])
      });
    }
  